import React, { useEffect, useState } from 'react';

import {

  Box,

  Typography,

  Paper,

  Button,

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

  TextField,

  Accordion,

  AccordionSummary,

  AccordionDetails,

  Table,

  TableBody,

  TableCell,

  TableContainer,

  TableHead,

  TableRow,

  Switch,

  IconButton,

  Chip,

  MenuItem,

  Select,

  FormControl,

  InputLabel,

  CircularProgress,

  Tooltip,

  Alert,

} from '@mui/material';

import {

  ExpandMore as ExpandMoreIcon,

  Add as AddIcon,

  DragIndicator as DragIcon,

  Edit as EditIcon,

} from '@mui/icons-material';

import { processingAPI } from '../Api';



const ProcessingGroups = () => {

  const [groups, setGroups] = useState([]);

  const [processings, setProcessings] = useState({});

  const [loading, setLoading] = useState(false);

  const [openNewGroup, setOpenNewGroup] = useState(false);

  const [newGroupName, setNewGroupName] = useState('');

  const [openMoveDialog, setOpenMoveDialog] = useState(false);

  const [selectedProcessing, setSelectedProcessing] = useState(null);

  const [targetGroup, setTargetGroup] = useState('');

  const [expandedGroups, setExpandedGroups] = useState({});

  const [draggedItem, setDraggedItem] = useState(null);

  const [draggedGroup, setDraggedGroup] = useState(null);

  const [alert, setAlert] = useState(null);



  useEffect(() => {

    loadData();

  }, []);



  const loadData = async () => {

    setLoading(true);

    try {

      const [groupsRes, allProcessingsRes] = await Promise.all([

        processingAPI.getGroups(),

        processingAPI.getList(),

      ]);



      const groupsList = groupsRes.data?.data || [];

      setGroups(['default', ...groupsList]);



      const allProcs = allProcessingsRes.data?.data || [];

      const grouped = {};



      allProcs.forEach((proc) => {

        const groupKey = proc.group || 'default';

        if (!grouped[groupKey]) {

          grouped[groupKey] = [];

        }

        grouped[groupKey].push({

          id: proc._id || proc.id,

          name: proc.name,

          key: proc.key,

          type: proc.type,

          status: proc.status,

          position: proc.position,

          group: proc.group,

          comission: proc.comission,

          conversion: proc.conversion,

        });

      });



      Object.keys(grouped).forEach((key) => {

        grouped[key].sort((a, b) => a.position - b.position);

      });



      setProcessings(grouped);

    } catch (error) {

      console.error('Error loading data:', error);

    } finally {

      setLoading(false);

    }

  };



  const handleCreateGroup = async () => {

    if (!newGroupName.trim()) return;

    setOpenNewGroup(false);

    setNewGroupName('');

    if (!groups.includes(newGroupName)) {

      setGroups([...groups, newGroupName]);

      setProcessings({ ...processings, [newGroupName]: [] });

    }

  };



  const handleToggleGroup = (group) => {

    setExpandedGroups((prev) => ({

      ...prev,

      [group]: !prev[group],

    }));

  };



  const handleToggleStatus = async (procId, currentStatus) => {

    try {

      await processingAPI.update(procId, { status: !currentStatus });

      setProcessings((prev) => {

        const updated = { ...prev };

        Object.keys(updated).forEach((group) => {

          updated[group] = updated[group].map((p) =>

            p.id === procId ? { ...p, status: !currentStatus } : p

          );

        });

        return updated;

      });

    } catch (error) {

      console.error('Error toggling status:', error);

    }

  };



  const handleOpenMoveDialog = (processing) => {

    setSelectedProcessing(processing);

    setTargetGroup(processing.group || 'default');

    setOpenMoveDialog(true);

  };



  const handleMoveProcessing = async () => {

    if (!selectedProcessing) return;

    

    try {

      const newGroup = targetGroup === 'default' ? null : targetGroup;

      await processingAPI.moveToGroup(selectedProcessing.id, newGroup);

      setOpenMoveDialog(false);

      loadData();

    } catch (error) {

      console.error('Error moving processing:', error);

    }

  };



  const handleDragStart = (e, proc, groupKey) => {

    setDraggedItem(proc);

    setDraggedGroup(groupKey);

    e.dataTransfer.effectAllowed = 'move';

  };



  const handleDragOver = (e, targetProc, groupKey) => {

    e.preventDefault();

    if (!draggedItem || draggedGroup !== groupKey || draggedItem.id === targetProc.id) return;



    const items = [...(processings[groupKey] || [])];

    const draggedIdx = items.findIndex(p => p.id === draggedItem.id);

    const targetIdx = items.findIndex(p => p.id === targetProc.id);



    if (draggedIdx === -1 || targetIdx === -1) return;



    items.splice(draggedIdx, 1);

    items.splice(targetIdx, 0, draggedItem);



    setProcessings(prev => ({

      ...prev,

      [groupKey]: items,

    }));

  };



  const handleDragEnd = async () => {

    if (!draggedItem || !draggedGroup) return;



    try {

      const items = processings[draggedGroup] || [];

      const order = items.map(item => item.id);

      const group = draggedGroup === 'default' ? 'null' : draggedGroup;

      await processingAPI.reorderInGroup(group, order);

      setAlert(<Alert severity="success">Порядок обновлён</Alert>);

    } catch (error) {

      console.error('Error reordering:', error);

      setAlert(<Alert severity="error">Ошибка изменения порядка</Alert>);

      loadData();

    } finally {

      setDraggedItem(null);

      setDraggedGroup(null);

    }

  };



  const getTypeLabel = (type) => {

    const labels = {

      card: 'Карта',

      cardsng: 'Карта СНГ',

      crypto: 'Крипто',

      p2purl: 'P2P URL',

    };

    return labels[type] || type;

  };



  const getTypeColor = (type) => {

    const colors = {

      card: 'primary',

      cardsng: 'secondary',

      crypto: 'success',

      p2purl: 'warning',

    };

    return colors[type] || 'default';

  };



  if (loading) {

    return (

      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">

        <CircularProgress />

      </Box>

    );

  }



  return (

    <Box sx={{ p: 3 }}>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>

        <Typography variant="h4">Группы процессингов</Typography>

        <Button

          variant="contained"

          startIcon={<AddIcon />}

          onClick={() => setOpenNewGroup(true)}

        >

          Создать группу

        </Button>

      </Box>

      {alert && <Box mb={2}>{alert}</Box>}



      {groups.map((group) => {

        const groupProcessings = processings[group] || [];

        const isExpanded = expandedGroups[group] !== false;



        return (

          <Accordion

            key={group}

            expanded={isExpanded}

            onChange={() => handleToggleGroup(group)}

            sx={{ mb: 2 }}

          >

            <AccordionSummary expandIcon={<ExpandMoreIcon />}>

              <Box display="flex" alignItems="center" gap={2} width="100%">

                <Typography variant="h6">

                  {group === 'default' ? 'Без группы' : group}

                </Typography>

                <Chip

                  label={`${groupProcessings.length} процессингов`}

                  size="small"

                  color="primary"

                />

              </Box>

            </AccordionSummary>

            <AccordionDetails>

              {groupProcessings.length === 0 ? (

                <Typography color="text.secondary">

                  Нет процессингов в этой группе

                </Typography>

              ) : (

                <TableContainer component={Paper}>

                  <Table>

                    <TableHead>

                      <TableRow>

                        <TableCell width="50px"></TableCell>

                        <TableCell>Название</TableCell>

                        <TableCell>Ключ</TableCell>

                        <TableCell>Тип</TableCell>

                        <TableCell>Комиссия</TableCell>

                        <TableCell>Конверсия</TableCell>

                        <TableCell>Статус</TableCell>

                        <TableCell>Действия</TableCell>

                      </TableRow>

                    </TableHead>

                    <TableBody>

                      {groupProcessings.map((proc) => (

                        <TableRow

                          key={proc.id}

                          draggable

                          onDragStart={(e) => handleDragStart(e, proc, group)}

                          onDragOver={(e) => handleDragOver(e, proc, group)}

                          onDragEnd={handleDragEnd}

                          sx={{

                            cursor: 'move',

                            opacity: draggedItem?.id === proc.id ? 0.5 : 1,

                            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },

                          }}

                        >

                          <TableCell>

                            <DragIcon sx={{ color: 'action.active', cursor: 'grab' }} />

                          </TableCell>

                          <TableCell>{proc.name}</TableCell>

                          <TableCell>

                            <code>{proc.key}</code>

                          </TableCell>

                          <TableCell>

                            <Chip

                              label={getTypeLabel(proc.type)}

                              size="small"

                              color={getTypeColor(proc.type)}

                            />

                          </TableCell>

                          <TableCell>

                            {proc.comission

                              ? `${((proc.comission - 1) * 100).toFixed(1)}%`

                              : '0%'}

                          </TableCell>

                          <TableCell>

                            {proc.conversion ? `${proc.conversion}%` : '-'}

                          </TableCell>

                          <TableCell>

                            <Switch

                              checked={proc.status}

                              onChange={() =>

                                handleToggleStatus(proc.id, proc.status)

                              }

                              size="small"

                            />

                          </TableCell>

                          <TableCell>

                            <Tooltip title="Переместить в группу">

                              <IconButton

                                size="small"

                                onClick={() => handleOpenMoveDialog(proc)}

                              >

                                <EditIcon fontSize="small" />

                              </IconButton>

                            </Tooltip>

                          </TableCell>

                        </TableRow>

                      ))}

                    </TableBody>

                  </Table>

                </TableContainer>

              )}

            </AccordionDetails>

          </Accordion>

        );

      })}



      <Dialog open={openNewGroup} onClose={() => setOpenNewGroup(false)}>

        <DialogTitle>Создать новую группу</DialogTitle>

        <DialogContent>

          <TextField

            autoFocus

            margin="dense"

            label="Название группы"

            fullWidth

            value={newGroupName}

            onChange={(e) => setNewGroupName(e.target.value)}

            onKeyPress={(e) => {

              if (e.key === 'Enter') handleCreateGroup();

            }}

          />

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setOpenNewGroup(false)}>Отмена</Button>

          <Button onClick={handleCreateGroup} variant="contained">

            Создать

          </Button>

        </DialogActions>

      </Dialog>



      <Dialog open={openMoveDialog} onClose={() => setOpenMoveDialog(false)}>

        <DialogTitle>Переместить процессинг</DialogTitle>

        <DialogContent sx={{ minWidth: 300, pt: 2 }}>

          <Typography variant="body2" color="text.secondary" mb={2}>

            {selectedProcessing?.name}

          </Typography>

          <FormControl fullWidth>

            <InputLabel>Группа</InputLabel>

            <Select

              value={targetGroup}

              onChange={(e) => setTargetGroup(e.target.value)}

              label="Группа"

            >

              {groups.map((group) => (

                <MenuItem key={group} value={group}>

                  {group === 'default' ? 'Без группы' : group}

                </MenuItem>

              ))}

            </Select>

          </FormControl>

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setOpenMoveDialog(false)}>Отмена</Button>

          <Button onClick={handleMoveProcessing} variant="contained">

            Переместить

          </Button>

        </DialogActions>

      </Dialog>

    </Box>

  );

};



export default ProcessingGroups;

